module.exports = __webpack_public_path__ + "src/assets/games/27/1631.jpg";